import { DataItemType, FormControlType } from "@cloudpivot/form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "./components/pc-checkbox-group.vue";
import mobile from "./components/mobile-checkbox-group.vue";
export const info = {
    title: "单选框",
    type: "single-selection",
    icon: "h-icon-all-single-selection-o",
    dataItemType: DataItemType.Radio,
    formControllerType: FormControlType.Radio,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
